import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const loginData = createAsyncThunk("login/loginData", async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/login`,
      data,
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
});

const loginSlice = createSlice({
  name: "login",
  initialState: {
    login: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginData.fulfilled, (state, action) => {
        state.loading = false;
        state.login = action.payload;
      })
      .addCase(loginData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
